import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Space, Typography, Alert, Result } from 'antd';
import { UserAddOutlined } from '@ant-design/icons';
import { useGuestSession } from '../../services/useGuestSession';
import { linkAccountToGuest } from '../../services/guestAuth.service';
import { useAuth } from '../../hooks/useAuth';

const { Title, Paragraph } = Typography;

export default function GuestAccountLinkPage() {
  const navigate = useNavigate();
  const session = useGuestSession();
  const { accessToken, isAuthenticated } = useAuth() as any;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  if (!session.isActive) {
    return (
      <div style={{ maxWidth: 480, margin: '40px auto', padding: '0 16px' }}>
        <Alert type="warning" message="Sessão de convidado não encontrada" description="Faça login com seu telefone primeiro." showIcon />
      </div>
    );
  }

  async function handleLink() {
    if (!isAuthenticated || !accessToken) {
      navigate('/login', { state: { redirect: '/guest/account-link' } });
      return;
    }
    setError(null);
    setLoading(true);
    try {
      await linkAccountToGuest(session.token!, accessToken);
      session.clear();
      setDone(true);
    } catch (err: any) {
      setError(err.response?.data?.message ?? 'Erro ao vincular conta.');
    } finally {
      setLoading(false);
    }
  }

  if (done) {
    return (
      <div style={{ maxWidth: 480, margin: '40px auto', padding: '0 16px' }}>
        <Result
          status="success"
          title="Conta vinculada com sucesso!"
          subTitle="Seu histórico de participações foi associado à sua conta PePoll."
          extra={[
            <Button type="primary" key="home" onClick={() => navigate('/')}>
              Ir para o início
            </Button>,
          ]}
        />
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 480, margin: '40px auto', padding: '0 16px' }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Title level={4} style={{ margin: 0 }}>
            <UserAddOutlined /> Vincular conta
          </Title>

          {error && <Alert message={error} type="error" showIcon />}

          <Paragraph type="secondary">
            Ao vincular sua conta PePoll, seu histórico de participações por telefone ficará acessível quando você entrar com seu email.
          </Paragraph>

          {isAuthenticated ? (
            <Button type="primary" block size="large" loading={loading} onClick={handleLink} icon={<UserAddOutlined />}>
              Vincular à minha conta
            </Button>
          ) : (
            <>
              <Alert type="info" message="Você precisa estar logado para vincular a conta." showIcon />
              <Button type="primary" block size="large" onClick={() => navigate('/login', { state: { redirect: '/guest/account-link' } })}>
                Entrar para vincular
              </Button>
            </>
          )}

          <Button type="link" block onClick={() => navigate(-1)}>
            Agora não
          </Button>
        </Space>
      </Card>
    </div>
  );
}
